import React from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../Component/Loader";
import "swiper/css";
import "swiper/css/effect-creative";
import "swiper/css/effect-fade";
import "swiper/css/effect-cube";
import { Autoplay } from "swiper/modules";
import { useEffect } from "react";
import useBreakPoints from "../../hooks/useBreakPoints";
import { Swiper, SwiperSlide } from "swiper/react";

const Testimonials = () => {
  const navigate = useNavigate();
  const {isMobile,isTablet,  isLaptop} = useBreakPoints()
  const [loading, setloading] = useState(false);
  const [allTestimonals, setAllTestimonals] = useState([]);

  const getAllTestimonialsApi = () => {
    const token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");

    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}testimonialslist?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token")
        ) {
          localStorage.clear();
          navigate("/logout");
        }
        if (data && data.status) {
          setAllTestimonals(data?.testimonialsList);
        } else if (data.message !== "Invalid token") {
          setloading(false);
        }
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };

  useEffect(() => {
    getAllTestimonialsApi();
  }, []);

  if (loading) {
    <Loader />;
  }
  return (
    <div class="wdt-elementor-container-fluid cust-header">
      <div
        data-elementor-type="wp-page"
        data-elementor-id="194"
        class="elementor elementor-194"
      >
        <section
          class="custom-slider-home-2 elementor-section elementor-top-section elementor-element elementor-element-6c516fe elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="6c516fe"
          data-element_type="section"
          data-settings='{"wdt_bg_image":{"url":"","id":"","size":""},"wdt_bg_image_laptop":{"url":"","id":"","size":""},"wdt_bg_image_tablet_extra":{"url":"","id":"","size":""},"wdt_bg_image_tablet":{"url":"","id":"","size":""},"wdt_bg_image_mobile_extra":{"url":"","id":"","size":""},"wdt_bg_image_mobile":{"url":"","id":"","size":""},"wdt_bg_position":"center center","wdt_animation_effect":"none"}'
        >
          <div class="elementor-container elementor-column-gap-no">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-44f9e85"
              data-id="44f9e85"
              data-element_type="column"
            >
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-73ee7eb before-title center  elementor-widget elementor-widget-wdt-heading"
                  data-id="73ee7eb"
                  data-element_type="widget"
                  data-settings='{"split_heading":"true","wdt_enable_inview_status":"true","_animation":"fadeInUp","_animation_delay":200,"header_decorative_elements_icon_align":"before-title","item_align":"center","title_vertical_align":"center","subtitle_vertical_align":"center","wdt_animation_effect":"none"}'
                  data-widget_type="wdt-heading.default"
                >
                  <div class="elementor-widget-container">
                    <div
                      class="wdt-heading-holder  wdt-heading-wrapper-center"
                      id="wdt-heading-73ee7eb"
                    >
                      <div class="wdt-heading-subtitle-wrapper wdt-heading-align-center wdt-heading-deco-wrapper">
                        <span class="wdt-heading-subtitle">
                          <span class="wdt-heading-deco-inner wdt-left-part">
                            <span class="wdt-heading-deco-icon">
                              <span class="wdt-content-icon-wrapper">
                                <span class="wdt-content-icon">
                                  <span>
                                    <i>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 100 100"
                                      >
                                        <path d="M50,99L1,50L50,1l49,49L50,99z"></path>
                                      </svg>
                                    </i>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                          Customer Satisfaction, Rated by You
                          <span class="wdt-heading-deco-inner wdt-right-part"></span>
                        </span>
                      </div>
                      <h2 class="wdt-heading-title-wrapper wdt-heading-align-center ">
                        <span class="wdt-heading-title">
                          <span class="wdt-split-heading-wrapper">
                            <span class="wdt-split-heading-title">T</span>
                            <span class="wdt-split-heading-title">e</span>
                            <span class="wdt-split-heading-title">s</span>
                            <span class="wdt-split-heading-title">t</span>
                            <span class="wdt-split-heading-title">i</span>
                            <span class="wdt-split-heading-title">m</span>
                            <span class="wdt-split-heading-title">o</span>
                            <span class="wdt-split-heading-title">n</span>
                            <span class="wdt-split-heading-title">i</span>
                            <span class="wdt-split-heading-title">a</span>
                            <span class="wdt-split-heading-title">l</span>
                            <span class="wdt-split-heading-title">s</span>
                          </span>
                          <span class="wdt-split-heading-wrapper">
                            <span class="wdt-split-heading-title">T</span>
                            <span class="wdt-split-heading-title">h</span>
                            <span class="wdt-split-heading-title">a</span>
                            <span class="wdt-split-heading-title">t</span>
                          </span>
                          <span class="wdt-split-heading-wrapper">
                            <span class="wdt-split-heading-title">I</span>
                            <span class="wdt-split-heading-title">n</span>
                            <span class="wdt-split-heading-title">s</span>
                            <span class="wdt-split-heading-title">p</span>
                            <span class="wdt-split-heading-title">i</span>
                            <span class="wdt-split-heading-title">r</span>
                            <span class="wdt-split-heading-title">e</span>
                          </span>
                        </span>
                      </h2>
                    </div>{" "}
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-dd6991d start wdt-cus-home-3-testimonial-style   elementor-widget elementor-widget-wdt-testimonial"
                  data-id="dd6991d"
                  data-element_type="widget"
                  data-settings='{"slides_to_show_opts":"2","gap":{"unit":"dpt","size":"50","sizes":[]},"item_align":"start","slides_to_show_opts_laptop":"2","speed":"100","gap_laptop":{"unit":"px","size":"40","sizes":[]},"gap_tablet":{"unit":"px","size":"30","sizes":[]},"slides_to_show_opts_mobile":"1","_animation":"fadeInUp","_animation_delay":300,"direction":"horizontal","effect":"default","slides_to_show_opts_tablet_extra":2,"slides_to_show_opts_tablet":2,"slides_to_show_opts_mobile_extra":1,"slides_to_scroll_opts":"single","mouse_wheel_scroll":"false","pagination":"bullets","gap_tablet_extra":{"unit":"px","size":"","sizes":[]},"gap_mobile_extra":{"unit":"px","size":"","sizes":[]},"gap_mobile":{"unit":"px","size":"","sizes":[]},"allow_touch":"yes","carousel_arrows_prev_arrow_vertical_align":"flex-start","carousel_arrows_prev_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_prev_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_align":"flex-start","carousel_arrows_next_arrow_vertical_top_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_vertical_top_indent_mobile":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_laptop":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_tablet":{"unit":"%","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile_extra":{"unit":"px","size":"","sizes":[]},"carousel_arrows_next_arrow_horizontal_left_indent_mobile":{"unit":"%","size":"","sizes":[]},"wdt_animation_effect":"none"}'
                  data-widget_type="wdt-testimonial.default"
                >
                  <div class="elementor-widget-container">
                    <div
                      class="wdt-testimonial-holder  wdt-content-item-holder wdt-carousel-holder wdt-rc-template-custom-template"
                      id="wdt-testimonial-dd6991d"
                      data-id="dd6991d"
                      data-settings=""
                    >
                      <Swiper
                        grabCursor={true}
                        loop
                        slidesPerView={
                          isMobile ? 1 : isTablet ? 1 : isLaptop ? 1 : 2
                        }
                        spaceBetween={40}
                        autoplay={{
                          delay: 2500,
                          disableOnInteraction: false,
                        }}
                        modules={[Autoplay]}
                        className="wdt-testimonial-container swiper"
                        wrapperClass="wdt-testimonial-wrapper swiper-wrapper"
                      >
                        {allTestimonals?.map((item, i) => (
                          <SwiperSlide key={i}>
                            <div class="wdt-content-item">
                              <div class="wdt-content-media-group">
                                <div class="wdt-content-image-wrapper ">
                                  <div class="wdt-content-image">
                                    <span>
                                      <img
                                        loading="lazy"
                                        decoding="async"
                                        width="200"
                                        height="200"
                                        src={item?.reviewerProfileImage}
                                        class="attachment-full size-full wp-image-156"
                                        alt=""
                                        sizes="(max-width: 200px) 100vw, 200px"
                                      />
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="wdt-content-detail-group">
                                <div class="wdt-content-description">
                                  {item?.review}
                                </div>
                                <div class="wdt-content-elements-group wdt-content-group ">
                                  <div class="wdt-content-icon-wrapper">
                                    <div class="wdt-content-icon">
                                      <span>
                                        <i>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 60 60"
                                            style={{
                                              enableBackground: "new 0 0 60 60",
                                            }}
                                          >
                                            <path d="M1.9,4.8c0.2-0.1,0.4-0.1,0.6-0.1c7.6,0,15.2,0,22.7,0c0.2,0,0.4,0,0.7,0c0,0.2,0.1,0.3,0.1,0.5c0,8.5,0.2,17.1-0.1,25.6 c-0.2,8.7-4,15.4-10.7,20.2c-3.8,2.8-8.2,4.1-12.9,4.2c-0.2,0-0.3,0-0.4,0c0-2.8,0-5.6,0-8.4c0.8-0.1,1.6-0.1,2.4-0.2 c6.8-1,12.1-6.4,13.4-13.4c0.2-1,0.2-2.1,0.3-3.2c-5.5,0-10.8,0-16.1,0C1.9,21.6,1.9,13.2,1.9,4.8z"></path>
                                            <path d="M58.1,31.6c-0.2,1-0.2,2.1-0.4,3.1c-1.2,6.5-4.4,11.8-9.4,15.7c-4,3.1-8.6,4.7-13.6,4.8c-0.2,0-0.3,0-0.4,0 c-0.1,0-0.1,0-0.1-0.1c0-2.8,0-5.5,0-8.3c5.5-0.2,9.9-2.5,13.1-7.3c1.9-2.8,2.8-6,2.9-9.6c-5.3,0-10.7,0-16,0c0-8.5,0-16.8,0-25.3 c0.2,0,0.3,0,0.5,0c7.7,0,15.4,0,23.1,0c0.2,0,0.3,0,0.4,0.1C58.1,13.7,58.1,22.7,58.1,31.6z"></path>
                                          </svg>
                                        </i>
                                      </span>
                                    </div>
                                  </div>
                                  <div class="wdt-content-title-group beside">
                                    <div class="wdt-content-title">
                                      <h5>{item?.name} </h5>
                                    </div>
                                    <span></span>
                                    <div class="wdt-content-subtitle">
                                      {item?.designation}
                                    </div>
                                  </div>
                                </div>
                                    <div class="wdt-content-subtitle">
                                      {item?.companyName}
                                    </div>
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                      <div class="wdt-carousel-pagination-wrapper">
                        <div class="wdt-swiper-pagination wdt-swiper-pagination-dd6991d"></div>
                      </div>
                    </div>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Testimonials;
